import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import Icon from '../components/ui/Icon'

const STEPS = [
  {
    number: '1',
    title: 'Go to প্রোফাইল',
    description: 'Tap the "Profile" icon on the bottom-right of the navigation bar.',
    image: '/screenshots/step-1.png',
    alt: 'Screenshot showing the profile tab',
  },
  {
    number: '2',
    title: 'Tap "অ্যাকাউন্ট মুছে ফেলুন"',
    description: 'Scroll to the bottom of your Profile page. You will find a red "Delete Account" button — tap it.',
    image: '/screenshots/step-2.png',
    alt: 'Screenshot showing the delete account button',
  },
  {
    number: '3',
    title: 'Confirm Deletion by clicking "মুছে ফেলুন"',
    description: 'A confirmation dialog will appear. Tap "Delete" to permanently delete your account.',
    image: '/screenshots/step-3.png',
    alt: 'Screenshot showing the confirmation dialog',
    warning: true,
  },
]

const DeleteAccountGuide = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />

      <div className="container mx-auto px-4 py-10 max-w-3xl">
        {/* Header */}
        <div className="text-center mb-10">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <Icon name="Trash2" className="w-8 h-8 text-red-600" />
          </div>
          <h1 className="text-2xl font-bold text-gray-900 mb-2">How to Delete Your Account</h1>
          <p className="text-gray-500 text-sm max-w-md mx-auto">
            Follow the steps below to permanently delete your FajrFighter account.
          </p>
        </div>

        {/* Warning Banner */}
        <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 flex items-start space-x-3 mb-10">
          <Icon name="AlertTriangle" className="w-5 h-5 text-amber-500 flex-shrink-0 mt-0.5" />
          <p className="text-sm text-amber-800">
            <strong>Warning:</strong> Deleting your account will permanently remove all your data, streaks, and activity. This action cannot be undone.
          </p>
        </div>

        {/* Steps */}
        <div className="space-y-12">
          {STEPS.map((step, index) => (
            <div key={index} className="flex flex-col items-center">
              {/* Step indicator */}
              <div className="flex items-center space-x-3 self-start mb-5">
                <div className="w-9 h-9 rounded-full bg-red-600 text-white flex items-center justify-center font-bold text-sm flex-shrink-0">
                  {step.number}
                </div>
                <h2 className="text-lg font-semibold text-gray-900">{step.title}</h2>
              </div>

              {/* Screenshot */}
              <div className="w-full flex justify-center mb-5">
                <div className="rounded-2xl overflow-hidden shadow-lg border border-gray-200 max-w-[220px] w-full">
                  <img
                    src={step.image}
                    alt={step.alt}
                    className="w-full h-auto block"
                  />
                </div>
              </div>

              {/* Description */}
              <div className={`w-full rounded-xl p-4 text-sm ${step.warning ? 'bg-red-50 border border-red-200 text-red-800' : 'bg-gray-50 border border-gray-100 text-gray-700'}`}>
                {step.warning && (
                  <div className="flex items-center space-x-2 mb-1">
                    <Icon name="AlertCircle" className="w-4 h-4 text-red-500" />
                    <span className="font-semibold text-red-700">This step is irreversible</span>
                  </div>
                )}
                {step.description}
              </div>

              {/* Connector (not after last step) */}
              {index < STEPS.length - 1 && (
                <div className="flex justify-center mt-6">
                  <Icon name="ChevronDown" className="w-6 h-6 text-gray-300" />
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Footer note */}
        <div className="mt-12 bg-blue-50 border border-blue-100 rounded-xl p-5 text-center">
          <Icon name="Info" className="w-5 h-5 text-blue-500 mx-auto mb-2" />
          <p className="text-sm text-blue-700">
            After deleting your account, you can register again at any time.
          </p>
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default DeleteAccountGuide
